import React, { ReactNode, useMemo, useState } from 'react';
import { BrukerinfoDto } from '../api/generated/studiested-generated-api';

export interface UhaUserStore {
  uhaUser: BrukerinfoDto | undefined;
  setUhaUser: (user: BrukerinfoDto) => void;
}

export const UhaUserContext = React.createContext<UhaUserStore>({
  uhaUser: undefined,
  setUhaUser: () => {},
});

export const UhaUserProvider: React.FC<
  React.PropsWithChildren<{ children: ReactNode }>
> = ({ children }) => {
  const [uhaUser, setUhaUser] = useState<BrukerinfoDto | undefined>();

  const userStore: UhaUserStore = useMemo(
    () => ({
      uhaUser,
      setUhaUser,
    }),
    [uhaUser],
  );

  return (
    <UhaUserContext.Provider value={userStore}>
      {children}
    </UhaUserContext.Provider>
  );
};
